import React from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import countries from "../../app/countries";

export const countrySelector = (country, handleClick) => {
  const currentCountry = countries.find((ct) => ct.value === country);

  return (
    <InputAdornment position="end">
      <IconButton onClick={handleClick}>
        <currentCountry.icon />
      </IconButton>
    </InputAdornment>
  );
};
